import { initPagePdf } from '@/pages-pdf/init'

initPagePdf()
